import React from 'react';

interface IArrowProps {
    curPage: number;
    numPages: number;
    onChangePage: React.MouseEventHandler<any>;
    children: React.ReactNode;
}

const PageArrows: React.StatelessComponent<IArrowProps> = (props: IArrowProps) => {
    const { children, curPage, numPages, onChangePage } = props;
    return(
        <span>
            {curPage !== 1 &&
                <span>
                    <a href="#" id="1" onClick={onChangePage}>&lt;&lt;</a>
                    <a href="#" id={(curPage - 1).toString()} onClick={onChangePage}>&lt;</a>
                </span>
            }
            {children}
            {curPage !== numPages &&
                <span>
                    <a href="#" id={(curPage + 1).toString()} onClick={onChangePage}>&gt;</a>
                    <a href="#" id={(numPages).toString()} onClick={onChangePage}>&gt;&gt;</a>
                </span>
            }
        </span>
    );
};

export default PageArrows;



// WEBPACK FOOTER //
// ./src/components/global/application/results_footer/PageArrows.tsx